import React from 'react'
import bottle from '../../assets/images/rotate-bottle.png';
export default function MultiBottle() {
  return (
    <div className="multi-bottle-wrap d-inline-flex">
        <div className="bottle-row row-1"> 
            <div className="bottle-item"><img src={bottle} alt="" /></div>
            <div className="bottle-item"><img src={bottle} alt="" /></div>
        </div>
        <div className="bottle-row row-2"> 
            <div className="bottle-item"><img src={bottle} alt="" /></div>
            <div className="bottle-item"><img src={bottle} alt="" /></div>
        </div>
        <div className="bottle-row row-3"> 
            <div className="bottle-item"><img src={bottle} alt="" /></div>
            <div className="bottle-item"><img src={bottle} alt="" /></div>
        </div>
    </div>
  )
}
